(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-heromain-lola]').forEach(function (section) {
    initFadeIn(section);
    initResponsiveMedia(section);
    if (!prefersReducedMotion) {
      initParallax(section);
    }
  });

  function initResponsiveMedia(section) {
    var mediaContainer = section.querySelector('[data-heromain-lola-media]');
    var templates = {
      desktop: {
        day: section.querySelector('template[data-heromain-lola-media="desktop"][data-heromain-lola-theme="day"]'),
        night: section.querySelector('template[data-heromain-lola-media="desktop"][data-heromain-lola-theme="night"]')
      },
      mobile: {
        day: section.querySelector('template[data-heromain-lola-media="mobile"][data-heromain-lola-theme="day"]'),
        night: section.querySelector('template[data-heromain-lola-media="mobile"][data-heromain-lola-theme="night"]')
      }
    };

    if (
      !mediaContainer ||
      !templates.desktop.day ||
      !templates.desktop.night ||
      !templates.mobile.day ||
      !templates.mobile.night
    ) {
      return;
    }

    var breakpoint = window.matchMedia('(min-width: 750px)');

    // Cache of every combination already activated this session, keyed
    // by "desktop-day" / "mobile-night" / etc. Nothing in here is ever
    // removed: once a variant has been cloned and started loading once,
    // switching away from it (theme toggle, or resizing across the
    // breakpoint) only HIDES it — pausing its video, not discarding it.
    // Switching back later just reveals it again, with zero network
    // cost. Before this, every single toggle destroyed the live element
    // and cloned a fresh one from scratch, forcing a brand new download
    // of the same multi-MB video file every time — confirmed in testing
    // (a handful of toggles produced dozens of full re-downloads of the
    // same file, 700+MB transferred for one page view).
    var liveElements = {};
    var lastKey = null;

    function currentTheme() {
      return document.documentElement.getAttribute('data-theme') === 'night' ? 'night' : 'day';
    }

    function activateWinner() {
      var widthKey = breakpoint.matches ? 'desktop' : 'mobile';
      var themeKey = currentTheme();
      var key = widthKey + '-' + themeKey;

      // Nothing to do if the correct combination is already the one
      // showing (e.g. a resize or theme toggle that didn't actually
      // change anything relevant — resizing within the same breakpoint,
      // for instance).
      if (key === lastKey) return;

      // Hide (never remove) whichever variant is currently showing.
      if (lastKey && liveElements[lastKey]) {
        var previousEl = liveElements[lastKey];
        previousEl.classList.add('heromain-lola__media-variant--hidden');
        var previousVideo = previousEl.querySelector('video');
        if (previousVideo) previousVideo.pause();
      }

      lastKey = key;

      var cached = liveElements[key];
      if (cached) {
        // Already created earlier this session — just reveal it again
        // and resume playback. No cloning, no load(), no new request.
        cached.classList.remove('heromain-lola__media-variant--hidden');
        var cachedVideo = cached.querySelector('video');
        if (cachedVideo) {
          var resumePromise = cachedVideo.play();
          if (resumePromise && typeof resumePromise.catch === 'function') {
            resumePromise.catch(function () {
              /* Ignore — if it was playing before it was hidden, this
                 essentially never fails in practice. */
            });
          }
        }
        return;
      }

      // First time this specific combination has ever been needed —
      // clone the <template>'s content, which is what actually triggers
      // the browser to start fetching the video/image for the FIRST
      // time. Kept in liveElements afterward so it never has to be
      // fetched again for the rest of this page view.
      var winningTemplate = templates[widthKey][themeKey];
      var fragment = winningTemplate.content.cloneNode(true);
      var wrapper = document.createElement('div');
      wrapper.className = 'heromain-lola__media-variant';
      wrapper.appendChild(fragment);

      // Inserted right before the templates themselves, so it stays
      // beneath the overlay (a later sibling) in paint order.
      mediaContainer.insertBefore(wrapper, templates.desktop.day);
      liveElements[key] = wrapper;

      var newVideo = wrapper.querySelector('video');
      if (newVideo) {
        // Cloning a <template> containing <video><source> doesn't always
        // trigger WebKit's resource selection algorithm for the new node —
        // some iOS Safari versions leave the element parked at
        // HAVE_NOTHING (no metadata, no first frame), which is exactly the
        // white frame + native play icon reported on iPhone. load() forces
        // Safari to (re)run source selection on this specific node.
        newVideo.load();

        var playPromise = newVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            // If play() still fails after load() (Low Power Mode, Safari's
            // "Never Auto-Play" setting, or a plain race condition), retry
            // once the browser confirms at least one frame is ready.
            newVideo.addEventListener('canplay', function onCanPlay() {
              newVideo.removeEventListener('canplay', onCanPlay);
              newVideo.play().catch(function () {
                /* Autoplay blocked persistently (e.g. a manual visitor
                   setting) — poster/native icon stays, expected in that
                   case. */
              });
            });
          });
        }
      }
    }

    breakpoint.addEventListener('change', activateWinner);

    // header-lola's theme toggle sets data-theme directly on <html> —
    // no custom event is dispatched anywhere for that change, so a
    // MutationObserver is the reliable way to react to it live,
    // regardless of which section/script actually triggered the
    // switch.
    var themeObserver = new MutationObserver(activateWinner);
    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    activateWinner();
  }

  function initFadeIn(section) {
    var content = section.querySelector('[data-heromain-lola-fade]');
    if (!content) return;

    // Two animation frames so the browser registers the initial (hidden)
    // state before the class flips, guaranteeing the CSS transition runs.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.classList.add('is-loaded');
      });
    });
  }

  function initParallax(section) {
    var content = section.querySelector('[data-heromain-lola-content]');
    if (!content) return;

    var speed = parseFloat(section.getAttribute('data-parallax-speed')) || 0.15;
    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        ticking = false;
        return;
      }

      // Content drifts slightly slower than the page scroll, giving a
      // gentle sense of depth relative to the (separately fixed/sticky)
      // header above it.
      var translateY = rect.top * speed * -1;
      content.style.transform = 'translate3d(0, ' + translateY.toFixed(1) + 'px, 0)';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
})();